<template>
  <div class="compare-detail">
    <my-form
      class="form-page"
      v-model="form"
      table
      label-width="160px"
      readonly
    >
      <el-form-item class="table-full-row" label="开始时间">
        {{ form.startTime }}
      </el-form-item>
      <el-form-item class="table-full-row" label="结束时间">
        {{ form.endTime }}
      </el-form-item>
      <el-form-item class="table-full-row" label="采购单位">
        {{ form.tbrDwname }}
      </el-form-item>
      <el-form-item
        class="table-full-row"
        label="代理机构"
        v-if="form.dwType == 'A'"
      >
        {{ form.dlDwname }}
      </el-form-item>
    </my-form>
    <div class="content-box" v-if="form.mode == '1'">
      <div class="content-tit">采购清单</div>
      <el-table
        stripe
        border
        :data="form.extVo.bodyValue"
        header-cell-class-name="inquiry-header-cell"
      >
        <el-table-column type="index" width="50" fixed> </el-table-column>
        <el-table-column
          v-for="offer in form.extVo.head.inquiryColumn"
          :label="offer.colname"
          :prop="offer.colcode"
          :key="offer.colcode"
        >
        </el-table-column>
      </el-table>
    </div>
    <div v-else class="total-tips">如需获取采购文件请登录系统查看详情</div>
  </div>
</template>

<script>
export default {
  props: {
    dataInfo: {
      type: Object,
    },
  },
  computed: {
    form() {
      return this.dataInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
.compare-detail {
  min-height: 407px;
  .tit {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    margin: 20px 0;
  }
  .total-tips {
    text-align: center;
    margin-top: 20px;
    color: #f56c6c;
    font-size: 18px;
  }
  .content-box {
    .content-tit {
      padding: 10px 0;
    }
  }
  .table-full-row {
    width: 100% !important;
  }
}
</style>
